import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../services/config';
import { ChangePasswordModel, ProfileModel, ProfileResponseModel } from './models';
import { ProfileEndpoint } from './constants/profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private http: WrapperHttpService) {}

  getProfile(): Observable<ProfileModel> {
    return this.http.withLoading().get<ProfileModel>(`${API_URL}${ProfileEndpoint.Base}`);
  }

  updateProfile(body: ProfileModel): Observable<ProfileResponseModel> {
    return this.http.withLoading().post<ProfileResponseModel>(`${API_URL}${ProfileEndpoint.Base}`, body);
  }

  changePassword(body: ChangePasswordModel): Observable<void> {
    return this.http.withLoading().post<void>(`${API_URL}${ProfileEndpoint.Password}${ProfileEndpoint.Change}`, body);
  }

  deleteProfile(): Observable<void> {
    return this.http.withLoading().delete<void>(`${API_URL}${ProfileEndpoint.Base}`);
  }

  acceptMapsPlugin(): Observable<void> {
    return this.http
      .withLoading()
      .post<void>(`${API_URL}${ProfileEndpoint.Base}${ProfileEndpoint.MapsPluginAccept}`, {});
  }
}
